import { EntityType } from '../../../@types/entityTypes';
import MsftGraphMessagesQuery from 'graphql/queries/system/MsftGraphMessagesQuery.graphql';

const GraphMessage: EntityType = {
  type: 'GraphMessage',
  title: 'Graph Messages',
  workspaceUrl: '/System/GraphMessage/Workspace/',
  workspace: MsftGraphMessagesQuery,
  screenReference: 'GRAPH_MESSAGES',
};

export default GraphMessage;
